export default {
    BASE_URL: '',
    api: [
        {
            name: 'projList',
            desc: '获取项目列表',
            method: 'GET',
            path: '/pms/my/list'
        },
        {
            name: 'projInfo',
            desc: '获取项目详情',
            method: 'GET',
            path: '/pms/detail/{id}'
        },
        {
            name: 'workOfType',
            desc: '获取工种分类',
            method: 'GET',
            path: '/pub/workType/tree'
        },
        {
            name: 'getWorkerManager',
            desc: '获取劳资员',
            method: 'GET',
            path: '/crm/member/labor/list'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/project/job/public.js